import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import { DEFAULT_PAGINATION, type FilterWithPaginationStateShape } from 'hooks/useFilterWithPagination';
import type { MetersByMeterModelsFilter } from 'lib/services';

const STATE_KEY = 'modelLibraryMetersTabState' as const;

type DefaultFilter = MetersByMeterModelsFilter;

export const DEFAULT_FILTER: DefaultFilter = {
  locations: undefined,
  search: undefined,
  sort: 'toolsId:ascend',
  toolsIds: undefined,
} as const;

const PAGINATION = {
  ...DEFAULT_PAGINATION,
  pageSize: 20,
} as const;

export type MetersByModelIdFilterWithPaginationShape = FilterWithPaginationStateShape<DefaultFilter>;

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: PAGINATION,
});

export const useMetersByModelIdWithPagination = (): MetersByModelIdFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
